import React from 'react';
import { Grid } from 'vindi-ds-components';

function CardsContainer({ children, ...props }) {
  return (
    <Grid container item {...props}>
      {children}
    </Grid>
  );
}

export default CardsContainer;
